import React from 'react'
import PropTypes from 'prop-types'

import ProductsTableLayout from '../ProductsTableLayout'

const SubscriptionsList = (props) =>
    <ProductsTableLayout
        noDataText="Create recurring payment options for membership or access to content"
        type="subscription"
        {...props}
    />

SubscriptionsList.propTypes = {
    items: PropTypes.array,
    loading: PropTypes.bool,
}

export default SubscriptionsList
